export const apiKey = process.env.REACT_APP_OPEN_AI_SECRET;

export const endpointCompletion = "https://api.openai.com/v1/engines/text-curie-001/completions";